import { Reducer } from 'redux';
import { AnomaliesState, AnomaliesTypes } from './types';

export const INITIAL_STATE: AnomaliesState = {
  anomalies: [],
  totalCount: 0,
  anomalyUsers: [],
  error: false,
  loading: false,
};

const reducer: Reducer<AnomaliesState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // LIST ANOMALIES
    case AnomaliesTypes.LIST_ANOMALIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        anomalies: INITIAL_STATE.anomalies,
      };
    case AnomaliesTypes.LIST_ANOMALIES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        anomalies: action.payload.anomalies,
        totalCount: action.payload.totalCount,
      };
    case AnomaliesTypes.LIST_ANOMALIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        anomalies: INITIAL_STATE.anomalies,
      };

    // LIST ANOMALY USERS
    case AnomaliesTypes.LIST_ANOMALY_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        anomalyUsers: INITIAL_STATE.anomalyUsers,
      };
    case AnomaliesTypes.LIST_ANOMALY_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        anomalyUsers: action.payload.anomalyUsers,
      };
    case AnomaliesTypes.LIST_ANOMALY_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        anomalyUsers: INITIAL_STATE.anomalyUsers,
      };

    default:
      return state;
  }
};

export default reducer;
